import { supabase } from "./lib/supabase";
import { getDeviceId } from "./getDeviceId";

export default async function checkIfVoted() {
  const deviceId = getDeviceId();

  const { data, error } = await supabase
    .rpc("has_device_voted", { p_device_id: deviceId });

  if (error) {
    console.error("Error checking vote:", error);
    return false;
  }

  return data === true;
}